import {LocationQueryValue} from "vue-router";

export class ApiError extends Error {
    code: string;

    constructor(code: string, message?: string) {
        super(message ?? code);
        this.code = code;
        this.name = 'ApiError';
    }
}

export async function parseErrorBody(response: Response): Promise<{ message: string; details?: unknown }> {
    const text = await response.text()
    if (!text) {
        return { message: response.statusText || 'Unknown error' }
    }
    try {
        const json = JSON.parse(text)
        // adjust field name(s) to match your Spring error response shape
        const message = json.message || json.error || json.detail || response.statusText
        return { message, details: json }
    } catch {
        // not JSON — fall back to raw text
        return { message: text }
    }
}


export function getCsrfToken(): string | null {
    const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/)
    let token = match ? decodeURIComponent(match[1]) : null
    return token
}

export async function initializeCsrfToken(): Promise<void> {

    const response = await fetch('/api/public/auth/csrf-token', {
        method: 'GET',
        credentials: 'include',
    })

    if (!response.ok) {
        throw new Error('Failed to initialize CSRF token')
    }
}

export function queryParam(value: LocationQueryValue | LocationQueryValue[] | undefined): string | undefined {
    const v = Array.isArray(value) ? value[0] : value
    return v ?? undefined
}
